<template lang="pug">
Auth(@loggedIn="onLoggedIn" @loginFailed="loginFailed")
  NowLoading(:show="showNowLoading")
  div.wrap-sign-ui.f.fh
    div.sign-ui
      div.f.fc
        div.wrap-title.mb30
          div.warp-logo
            img(v-if="env && env.indexOf('asc') > -1" src="/img/asc-online-logo.svg").object-fit-cover
            img(v-if="env && env.indexOf('zauna') > -1" src="/img/zauna-logo.svg").object-fit-cover
          //- div.warp-logo.mb2
          //-   img(src="/img/asc-logo.svg").object-fit-cover
          //- div.warp-logo
          //-   img(src="/img/logo.jpg").object-fit-cover
        div.wrap-sign-in-ui.mb24
      SignIn(@signInSuccess="onLoggedIn")
      //- div.wrap-select-sign-in-up.f.fc
        span(v-if="$route.name === 'sign-up'",
          @click="$router.push('/sign-in')") サインイン
        span(v-if="$route.name === 'sign-in'",
          @click="$router.push('/sign-up')") サインアップ
    div.wrap-powered-by.f.fc
      v-img(src="/img/powered-by-habit.svg").object-fit-cover
</template>

<style lang="scss" scoped>
.wrap-sign-ui {
  width: 100%;
  height: 100vh;
  position: relative;
  .sign-ui {
    position: relative;
    width: 92%;
    max-width: 620px;
    max-height: 460px;
    margin: 0 auto;
    
    .wrap-title {
      .warp-logo {
        width: 220px;
      }
    }
  }
  .wrap-powered-by {
    position: absolute;
    width: 140px;
    bottom: 24px;
    img {
      width: 140px;
    }
  }
}
</style>

<script>
import db, { firebase, env } from "@/components/utils/firebase"
import { sendTrackingEvent, trackedUserSignUp, identifyTrackedUser } from "@/components/utils/eventTracker"
import { createNamespacedHelpers } from "vuex"
import Auth from "@/components/auth"
import SignIn from "@/components/sign-in/firebase-sign-in-ui"
import NowLoading from "@/components/shared/NowLoading"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  components: {
    Auth,
    SignIn,
    NowLoading
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    resultRedirect: null,
    redirectUrl: null,
    showNowLoading: true
  }),
  computed: {
    ...mapStateAuth(["isLoggedIn", "uid"]),
    env: function () {
      return env
    }
  },
  async created () {
    this.showNowLoading = false
  },
  mounted () {
    // setTimeout(() => {
    //   if (location.pathname.split("/")[1] === "sign-up") {
    //     document.getElementsByClassName("firebaseui-title")[0].innerText = "Sign Up with Email"
    //   }
    // }, 300)
    // if (this.uid && !this.isAnonymous) this.$router.push(`/home`)
  },
  methods: {
    loginFailed () {
      this.showNowLoading = false
    },
    async onLoggedIn () {
      this.showNowLoading = true

      await this.sleepByPromise(0.8)
      var firebaseUser = await firebase.auth().currentUser
      console.log("firebaseUser:", firebaseUser)

      if (this.uid) {
        this.showNowLoading = true

        var user = await firebase.auth().currentUser
        var trainerDoc = await db.collection("TRAINER").doc(this.uid).get()
        var traineeDoc = await db.collection("TRAINEE").doc(this.uid).get()

        identifyTrackedUser(this.uid)

        // trainer sign in
        if (trainerDoc.exists) {
          this.$router.push("/trainer/calendar")
          this.showNowLoading = false
          sendTrackingEvent("Trainer Sign in", {
            uid: this.uid,
            path: this.$route.name
          }, this.uid)
          return true
        }

        // trainee sign in
        if (traineeDoc.exists) {
          this.$router.push("/calendar")
          this.showNowLoading = false
          sendTrackingEvent("Trainee Sign in", {
            uid: this.uid,
            path: this.$route.name
          }, this.uid)
          return true
        }

        // trainer sign up
        if (!trainerDoc.exists && (this.$route.name === "trainer-sign-up" || this.$route.name === "trainer-sign-in")) {
          var userObj = {
            uid: user.uid,
            name: user.displayName,
            profile: "No Profile",
            photoURL: user.photoURL,
            type: "trainer",
            lastSignInTime: user.metadata.lastSignInTime,
            createdAt: user.metadata.creationTime
          }

          const defaultIcon = "https://firebasestorage.googleapis.com/v0/b/fir-tmp-project.appspot.com/o/public%2Faccount.png?alt=media&token=4ad2981f-61ac-42d9-a5ed-45eda74077d0"
          if (!userObj.photoURL) userObj.photoURL = defaultIcon

          await db.collection("TRAINER")
            .doc(user.uid)
            .set(userObj)
          
          userObj.$email = user.email
          trackedUserSignUp(userObj)
          sendTrackingEvent("Trainer Sign up", {
            uid: this.uid,
            $email: user.email,
            path: this.$route.name
          }, this.uid)

          this.$router.push("/trainer/calendar")

          this.showNowLoading = false
          return true
        }

        // trainee sign up
        if (!traineeDoc.exists && (this.$route.name === "sign-up" || this.$route.name === "sign-in")) {
          var userObj = {
            uid: user.uid,
            name: user.displayName,
            profile: "No Profile",
            photoURL: user.photoURL,
            type: "trainee",
            lastSignInTime: user.metadata.lastSignInTime,
            createdAt: user.metadata.creationTime
          }

          const defaultIcon = "https://firebasestorage.googleapis.com/v0/b/fir-tmp-project.appspot.com/o/public%2Faccount.png?alt=media&token=4ad2981f-61ac-42d9-a5ed-45eda74077d0"
          if (!userObj.photoURL) userObj.photoURL = defaultIcon

          await db.collection("TRAINEE")
            .doc(user.uid)
            .set(userObj)

          userObj.$email = user.email
          trackedUserSignUp(userObj)
          sendTrackingEvent("Trainee Sign up", {
            uid: this.uid,
            path: this.$route.name
          }, this.uid)
          
          this.$router.push("/calendar")

          this.showNowLoading = false
          return true
        }        
      }
      this.showNowLoading = false
    },
    signInSuccess (redirectUrl) {
      this.redirectUrl = redirectUrl
      // this.onLoggedIn()
    },
    sleepByPromise (sec) {
      return new Promise(resolve => setTimeout(resolve, sec * 1000))
    }
  }
}
</script>
